export default {
  landing: {
    title: "Régie Connect",
    subtitle: "Management solution for LED lighting professionals",
    admin: "Administration",
    adminDesc: "LED stock & operations",
    partner: "Partner",
    partnerDesc: "Partner space",
    installer: "Installer",
    installerDesc: "Appointments",
    commercial: "Sales",
    commercialDesc: "Schedule & documents",
    connect: "Log in",
    welcome: "Welcome to Régie Connect",
  },
  legal: {
    mentions: "Legal notice",
    cgu: "Terms of use",
    confidentiality: "Privacy",
    back: "Back",
  },
  paywall: {
    title: "Subscription required",
    description: "Your trial has ended. Choose a plan to continue accessing your admin interface.",
    choosePlan: "Choose a plan",
    redirecting: "Redirecting…",
    secureNote: "Secure payment via Stripe. In test mode, use card 4242 4242 4242 4242.",
    logout: "Log out",
  },
  auth: {
    accessAdmin: "Admin access",
    accessPartner: "Partner access",
    accessInstaller: "Installer access",
    accessCommercial: "Sales access",
    createAccount: "Create account",
    emailPlaceholder: "Email address",
    passwordPlaceholder: "Password",
    namePlaceholder: "Full name",
    codePlaceholder: "ACCESS CODE",
    login: "Log in",
    register: "Sign up",
    alreadyHaveAccount: "I already have an account",
    createAdminAccount: "Create admin account",
    forgotPassword: "Forgot password?",
    forgotCode: "Forgot code?",
    mfaTitle: "Two-factor authentication",
    mfaDescription: "Enter the 6-digit code from your app",
    mfaVerify: "Verify",
    mfaBack: "Back",
    secureAccess: "Secure sign-in",
    invalidLoginCredentials: "Incorrect email or password.",
    invalidLoginCredentialsLocal: "On localhost: make sure this account exists in your Supabase project (Dashboard → Authentication), or create one with « Create admin account ».",
    invalidRole: "Invalid role",
    allFieldsRequired: "All fields are required",
    emailPasswordRequired: "Email and password required",
    accessCodeRequired: "Access code required",
    mfaCodeRequired: "Enter the 6-digit code from your app",
    forgotPasswordTitle: "Forgot password?",
    forgotPasswordDesc: "Enter your email to receive a reset link",
    emailRequired: "Email required",
    sendLink: "Send link",
    backToLogin: "Back to login",
    emailSentTitle: "Email sent!",
    resetEmailSentTo: "A reset email has been sent to:",
    checkInbox: "Check your inbox and click the link to reset your password.",
    checkSpam: "Check your spam folder if you don't receive the email.",
    forgotCodeTitle: "Forgot code?",
    verification: "Verification",
    codeRecovered: "Code recovered!",
    enterEmail: "Enter your email",
    enterCodeReceived: "Enter the code received by email",
    yourAccessCodeDesc: "Here is your access code",
    sendVerificationCode: "Send verification code",
    verifyCode: "Verify code",
    newCodeSent: "New code sent!",
    noEmailReceived: "Didn't receive the email?",
    changeEmail: "Change email",
    resendCode: "Resend code",
    verificationSuccess: "Verification successful!",
    yourAccessCode: "Your access code",
    connectNow: "Log in now",
    verificationCodeRequired: "Verification code required",
    devEmailNote: "In production, email is sent via Supabase SMTP (Resend). In development, contact the administrator for the code.",
    codeSentTo: "A verification code was sent to",
    codeGeneratedFor: "Code generated for",
    checkSpamFolder: "Check your spam folder if you don't receive it.",
  },
  access: {
    manageCodesPartners: "Manage Partner Codes",
    manageCodesInstallers: "Manage Installer Codes",
    manageCodesCommercials: "Manage Sales Codes",
    createAccessCode: "Create access code",
    nameOrCompany: "Name / Company",
    codePlaceholder: "CODE",
    emailRequiredRecovery: "Email (REQUIRED for code recovery)",
    prefixTip: "A unique prefix will be added automatically to the code",
    emailTip: "Email is used to send the verification code (free)",
    assignedRegionOptional: "Assigned region (optional)",
    noRegion: "No region",
    add: "Add",
    save: "Save",
    cancel: "Cancel",
    codeLabel: "Code:",
    noEmailImpossible: "No email (recovery IMPOSSIBLE)",
    edit: "Edit",
    delete: "Delete",
    assignedRegion: "Assigned region",
    seePartnerOnJobs: "See partner on jobs",
    partnerManageOwnSchedule: "Manage own appointments (dates)",
    partnerManageOwnScheduleTooltip:
      "When enabled, this partner can set or change date and time on their own pending or scheduled jobs, and remove the appointment.",
    disablePartnerTooltip: "Disable: this installer will no longer see the partner",
    enablePartnerTooltip: "Enable: this installer will see the partner",
    codeCannotBeModified: "Code cannot be modified for security reasons",
    emailRequired: "Email (REQUIRED)",
  },
  settings: {
    title: "Account",
    subtitle: "Profile, security and preferences",
    sectionProfile: "Profile",
    sectionSecurity: "Security",
    sectionCompany: "Company",
    sectionIntegrations: "Integrations",
    sectionData: "Data",
    sectionNotifications: "Notifications",
    sectionSubscription: "Subscription",
    sectionDanger: "Delete my account",
    language: "Language",
    languageDesc: "Interface in French, English or Spanish",
    profilePhoto: "Profile photo",
    profilePhotoDesc: "Customize your avatar",
    change: "Change",
    remove: "Remove",
    security: "Security",
    password: "Password",
    back: "Back",
    data: "Data",
    dataDesc: "Import & export CSV or Excel",
    companyInfo: "Company information",
    companyInfoDesc: "Quotes and invoices",
    profilePhotoHint: "JPG, PNG, GIF · 2 MB max",
    apiKeys: "API Keys",
    apiKeysDesc: "Integrations and REST access",
    createKey: "Create key",
    deleteKey: "Delete key",
    docApi: "API documentation (OpenAPI)",
    webhooks: "Webhooks",
    webhooksDesc: "HTTP notifications (jobs created, updated, completed)",
    addWebhook: "Add webhook",
    active: "Active",
    inactive: "Inactive",
    enable: "Enable",
    disable: "Disable",
    newPassword: "New password",
    confirmPassword: "Confirm",
    passwordUpdated: "Password updated",
    changePasswordBtn: "Change password",
    changing: "Changing…",
    companyNameLabel: "Company name",
    companySiret: "SIRET",
    companyAddressLabel: "Address",
    companyPhoneLabel: "Phone",
    invoiceTemplateSection: "Quotes & invoices",
    invoiceTemplateDesc: "Customize the look of your quote and invoice PDFs.",
    myQuotes: "My quotes",
    myInvoices: "My invoices",
    matchWithQuote: "Match with quote",
    matchWithQuoteHint: "Select a job to use the same client and amount as the quote.",
    invoiceTemplateTheme: "Theme",
    invoiceTheme_minimal: "Minimal",
    invoiceTheme_minimal_desc: "Clean, thin lines, plenty of space.",
    invoiceTheme_classic: "Classic",
    invoiceTheme_classic_desc: "Subtle borders, balanced.",
    invoiceTheme_luxe: "Luxe",
    invoiceTheme_luxe_desc: "Strong accent, title bar, premium.",
    invoiceTemplateAccentColor: "Accent colour",
    invoiceTemplateFooter: "Custom footer",
    invoiceTemplateFooterPlaceholder: "Leave empty for default text. E.g. Legal notice, payment terms…",
    invoiceTemplateScripts: "Scripts and text",
    invoiceTemplateIntroText: "Introduction text",
    invoiceTemplateIntroPlaceholder: "Text shown at the top of the document (before Client / Date). E.g. Subject of the service…",
    invoiceTemplateTermsText: "Terms and conditions",
    invoiceTemplateTermsPlaceholder: "General terms, payment deadline, penalties… (shown after total).",
    invoiceTemplateLayout: "Layout",
    invoiceTemplatePageOrientation: "Page orientation",
    invoiceOrientation_portrait: "Portrait",
    invoiceOrientation_landscape: "Landscape",
    invoiceTemplateFontSize: "Text size",
    invoiceFontSize_small: "Small",
    invoiceFontSize_normal: "Normal",
    invoiceFontSize_large: "Large",
    invoiceTemplateLogoPosition: "Logo position",
    invoiceLogoPosition_left: "Left",
    invoiceLogoPosition_right: "Right",
    invoiceTemplatePreview: "Preview",
    invoicePreviewCompany: "My Company",
    invoiceTemplateAppearance: "Appearance",
    invoiceTemplateLogo: "Logo on document",
    invoiceTemplateUseProfilePhoto: "Use my profile photo as logo",
    invoiceTemplateLogoOrDrop: "Or drop an image below (drag and drop) or paste a URL.",
    invoiceTemplateDropLogo: "Drag and drop a logo or click to choose",
    invoiceTemplateLogoUrl: "Logo URL (optional)",
    invoiceTemplateLogoHint: "Public URL of an image (PNG or JPG). Shown in the document header.",
    saved: "Saved",
    saving: "Saving…",
    saveBtn: "Save",
    exportData: "Export your data",
    exportDataDesc: "Right to data portability (GDPR) · ZIP with jobs, stock, logs, etc.",
    downloadAll: "Download all",
    generating: "Generating…",
    exportJobs: "Export jobs",
    importJobs: "Import jobs",
    importJobsHint: "File .xlsx, .xls or .csv",
    chooseFile: "Choose file",
    download: "Download",
    notifications: "Notifications",
    notificationsDesc: "Enable or disable alerts",
    globalAlert: "Global alert",
    globalAlertDesc: "Receive notifications in the app (no email)",
    newJobsNotif: "New jobs",
    newJobsNotifDesc: "Get notified",
    miniSecretary: "Mini secretary",
    miniSecretaryDesc: "Notification bubble on CRM entry",
    mySubscription: "My subscription",
    billingPlan: "Billing and plan",
    currentStatus: "Current status",
    manageSubscription: "Manage subscription",
    security2FA: "Security",
    security2FADesc: "Two-step verification",
    scanQR: "Scan this QR code with your app (Google Authenticator, Authy, etc.) then enter the 6-digit code.",
    enterCode6: "6-digit code",
    cancel: "Cancel",
    validate: "Validate",
    verifying: "Verifying…",
    disable2FA: "Disable two-step verification",
    enable2FA: "Enable two-step verification",
    preparing: "Preparing…",
    dangerZone: "Danger zone",
    dangerZoneDesc: "Permanently delete account and all data",
    deleteAccountWarn: "This action deletes everything: jobs, partners, installers, stock, regions, history, subscription and your account. It is irreversible.",
    deleteAccountBtn: "Delete my account",
    deleteAccountModalTitle: "Permanently delete account",
    deleteAccountModalDesc: "Type DELETE to confirm. All data will be deleted.",
    deleteConfirmPlaceholder: "DELETE",
    deleting: "Deleting…",
    deletePermanently: "Delete permanently",
    newApiKey: "New API key",
    keyNameOptional: "Name (optional)",
    keyNamePlaceholder: "E.g. CRM integration",
    create: "Create",
    keyCreated: "Key created",
    keySaveNotice: "Save this key: it will not be shown again.",
    copy: "Copy",
    close: "Close",
    newWebhook: "New webhook",
    webhookUrlLabel: "Receiving URL",
    webhookUrlPlaceholder: "https://your-server.com/webhook",
    webhookEventsLabel: "Events",
    webhookEventsHint: "If none checked, all will be sent.",
    webhookSecret: "Webhook secret",
    webhookSecretNotice: "Use this secret to verify the signature (X-Webhook-Signature). It will not be shown again.",
    jobCreated: "Job created",
    jobUpdated: "Job updated",
    jobCompleted: "Job completed",
    sessionExpired: "Session expired. Please log in again.",
    createKeyError: "Error creating key",
    urlMustStart: "URL must start with https:// or http://",
    passwordMinLength: "Password must be at least 6 characters",
    passwordMismatch: "Passwords do not match",
    mfaScanSecret: "Or enter this secret manually:",
    mfaInvalidCode: "Invalid code",
    mfaEnrollError: "Error enabling 2FA",
    mfaUnenrollError: "Error disabling 2FA",
    mfaEnterCode6: "Enter the 6-digit code",
    mfaChallengeFail: "Challenge failed",
    planTrialing: "Free trial",
    planActive: "Pro",
    planPastDue: "Past due",
    planCanceled: "Canceled",
    planIncomplete: "Incomplete",
    csvClient: "Client",
    csvPhone: "Phone",
    csvAddress: "Address",
    csvStatus: "Status",
    csvDate: "Date",
    csvTime: "Time",
    csvSurface: "Surface",
    csvLightingType: "Lighting type",
    csvCeilingHeight: "Ceiling height",
    csvNotes: "Notes",
    csvCreatedAt: "Created at",
    statusPending: "Pending",
    statusScheduled: "Scheduled",
    statusInProgress: "In progress",
    statusCompleted: "Completed",
    statusCanceled: "Canceled",
    noValidRows: "No valid rows (Client or Address required).",
  },
  admin: {
    settings: "Account",
    home: "Home",
    overview: "Overview",
    jobs: "Jobs",
    stock: "Stock",
    team: "Team",
    planning: "Planning",
    regions: "Regions",
    partners: "Partners",
    installers: "Installers",
    budget: "Budget",
    access: "Access",
    workSection: "Work",
    organizationSection: "Organization",
    logout: "Log out",
    overviewCompleted: "Completed",
    overviewPending: "Pending",
    overviewTitle: "Dashboard",
    overviewSubtitle: "Quick access to what matters today.",
    overviewToSchedule: "To schedule",
    overviewToScheduleHint: "Pending or scheduled",
    overviewInProgressHint: "Jobs started",
    overviewDoneHint: "Closed or cancelled",
    overviewPlanningHint: "Calendar & appointments",
    overviewLowStock: "Low stock",
    overviewLowStockHint: "item(s) below threshold",
    overviewLowStockOk: "No alerts",
    overviewRecentActivity: "Recent activity",
    overviewClear: "Clear",
    overviewNoAccess:
      "You have no access to any section on this page. Use the menu according to your permissions.",
    jobsHubHint: "Choose a category to continue.",
    statusPending: "Pending",
    statusScheduled: "Scheduled",
    statusInProgress: "In progress",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    jobsInProgress: "Jobs in progress",
    noJobsInProgress: "No jobs in progress",
    client: "Client",
    address: "Address",
    phone: "Phone",
    region: "Region",
    installer: "Installer",
    dateCreated: "Date created",
    invoice: "Invoice (€)",
    newJob: "New job",
    newShort: "New",
    add: "Add",
    addRegion: "Add region",
    addPartner: "Add partner",
    newPartner: "New partner",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    budgetPartners: "Partner budget",
    seeDetail: "View details",
    noInvoiceYet: "No invoices yet",
    jobsInvoiced: "job(s) invoiced",
    budgetJobsLine: "{{count}} job(s) invoiced",
    monthlyEvolution: "Monthly trend (budget)",
    revenueTitle: "Revenue & sales",
    caTotal: "Total revenue",
    caThisMonth: "This month",
    avgTicket: "Avg. ticket",
    invoicesCount: "Invoices",
    trendLabel: "Trend vs last month",
    caChartHint: "Partner invoiced revenue (12 months). Net profit needs purchase costs not tracked here.",
    stockByPartnerRegion: "Stock by partner and region",
    stockDescription: "Stock is managed by partner and region. Select below to view or edit quantities.",
    stockOf: "Stock of",
    reference: "Reference",
    quantity: "Quantity",
    installersInRegion: "Installers in region",
    installersByRegion: "Installers by region. Click a region to see all.",
    regionLabel: "Region",
    installerLabel: "Installer",
    noRegion: "No region",
    unassigned: "Unassigned",
    searchPlaceholder: "Client, address, phone, installer…",
    statusLabel: "Status",
    typeLabel: "Type",
    filterStatus: "Status:",
    filterRegion: "Region:",
    filterInstaller: "Installer:",
    deleteRegionConfirm: "Delete region « {{name}} »? Stock in this region will also be deleted.",
    editRegion: "Edit region",
    deleteRegion: "Delete region",
    editPartners: "Edit partners",
    allRegions: "All regions",
    allPartners: "All partners",
    allInstallers: "All installers",
    allStatuses: "All statuses",
    allRegionsShort: "All regions",
    filterPlanning: "Filter planning",
    partnerLabel: "Partner",
    sortLabel: "Sort:",
    dateShort: "Date",
    searchLabel: "Search:",
    noRegionYet: "No region",
    addRegionsToSee: "Add regions to show installers by region.",
    byRegion: "By region",
    summaryOf: "Summary of {{count}} job(s) displayed (current filters and view).",
    jobSingular: "job",
    jobPlural: "jobs",
    jobCount: "job(s)",
    noInvoiceInRegion: "No invoices yet (completed and invoiced jobs will appear here).",
    regionDetailDesc: "Region detail: stock, installers, partners, jobs and invoices.",
    regionChooseDesc: "Choose a region to see full detail (stock, installers, partners, jobs, invoices).",
    stockByRegionDesc: "Stock by region. Click a region to see all.",
    jobsTabLabel: "Jobs",
    stocksTabLabel: "Stock",
    installerCount: "installer(s)",
    jobCountShort: "job(s)",
    newJobTitle: "New job (Admin)",
    assignInstaller: "Assign installer",
    assignCommercial: "Assign sales rep",
    assignToNobody: "Unassign",
    chooseOption: "— Choose —",
    fullAddressPlaceholder: "Full address",
    clientNamePlaceholder: "Client name",
    clientPhonePlaceholder: "Client phone",
    stockRegionNote: "Installer's region.",
    stockRegionHouseLabel: "Region (stock base)",
    mainRegionLabel: "Main region",
    stockRegionsTitle: "Stock regions",
    actions: "Actions",
    allFolder: "All",
    folderAdmin: "Admin",
    allJobsFolder: "All jobs",
    adminAndTeam: "Admin & Team",
    adjustStock: "Adjust stock",
    clearLabel: "Clear",
    importButton: "Import",
    importLoading: "Import…",
    listView: "List",
    summaryView: "Summary",
    budgetOverviewTab: "Overview",
    budgetTariffsTab: "Tariffs",
    budgetInvoicesTab: "Invoices",
    totalInvoiced: "Total invoiced",
    invoicesInRegion: "Invoices in region",
    partnersInRegion: "Partners in region",
    editTariff: "Edit tariff",
    budgetIntro: "Partner invoice amounts are calculated from tariffs by partner, region and dossier type (Tariffs tab). See the Invoices tab for detail by partner and job.",
    editReference: "Edit reference",
    editJob: "Edit job",
    viewJob: "View job",
    viewOnlyNoEdit: "View only — you don't have permission to edit this job",
    openDossier: "Open job",
    editReport: "Edit report",
    closeJob: "Close job",
    addStockUnit: "Add unit",
    manageInstallers: "Manage installers",
    statusCancelledClient: "Cancelled (client)",
    deleteRegionShortConfirm: "Delete this region? Associated stock will also be deleted.",
    editOrDeleteRegion: "Edit or delete this region",
    history: "History",
    jobsInvoicedCount: "Jobs invoiced",
    recalculateInvoices: "Recalculate invoices",
    recalculateLoading: "Recalculating…",
    tariffGrid: "Tariff grid",
    regieAdmin: "Regie Admin",
    loading: "Loading…",
    internalStock: "Internal stock",
    noRecentActivity: "No recent activity.",
    partnerPlaceholder: "Partner…",
    perPage: "Per page",
    goTo: "Go to",
    noJobs: "No jobs",
    noInstallerInRegion: "No installer assigned in this region.",
    newRegion: "New region",
    addRegionShort: "Add region",
    noRegionHere: "No region",
    alertLabel: "Alert",
    noStockInRegion: "No items in stock in this region.",
    noInstallerWithJobInRegion: "No installer with job in this region.",
    amount: "Amount",
    partnersTitle: "Partners",
    choosePartnerDesc: "Choose a partner to see their jobs by region.",
    chooseInstallerDesc: "Click an installer to see all their assigned jobs.",
    noPartnerInRegion: "No partner with job in this region.",
    noInstallerHere: "No installer",
    addInstallersInAccess: "Add installers in Access management.",
    allInstallersTitle: "All installers",
    loadingTariffs: "Loading tariffs…",
    chooseRegionOption: "Choose a region",
    newPrice: "New (€)",
    replacementPrice: "Replacement (€)",
    chooseReferenceOption: "Choose a reference",
    newLabel: "New",
    replacementLabel: "Replacement",
    unitPrice: "Unit price (€)",
    byPartner: "By partner",
    totalInvoicesByPartner: "Total invoices (completed jobs) by partner.",
    invoiceDetail: "Invoice detail",
    noJobWithPartner: "No completed job with partner.",
    seeStockOf: "View stock of:",
    choosePartnerOption: "Choose a partner…",
    noReferenceForPartner: "No reference for this partner.",
    nameQtyAlert: "Name, quantity and alert threshold.",
    detailsAndPlanning: "Details and planning",
    jobTypeLabel: "Job type",
    led: "LED",
    dehumidifier: "Dehumidifier",
    nameOrFirstName: "Name / First name",
    jobCancelledByClient: "Job cancelled by client.",
    technicalVisit: "Technical visit",
    installation: "Installation",
    quantitiesPlaced: "Quantities installed (new / replacement) and comment",
    createJobDesc: "Create a job and optionally assign it to a team",
    contextStockUsed: "Context: stock used",
    businessBringer: "Business bringer",
    noPartnerInternal: "No partner (internal stock)",
    chooseRegionDot: "Choose a region...",
    clientAndTech: "Client & technical",
    typeDot: "Type...",
    notesLabel: "Notes",
    chooseTeam: "Choose a team...",
    chooseJobTypeAlert: "Please choose the job type (LED exterior, LED interior, Dehumidifier, VMC Agricoles, TH 122, or Renovation).",
    errorAiSearch: "AI search error",
    errorAiSuggest: "AI suggestion error",
    errorAiStock: "AI stock suggestion error",
    noItemInRegion: "No item in this region",
    noValidRowImport: "No valid row (Client or Address required).",
    errorImport: "Import error.",
    readFileError: "Could not read file",
    invoiceLabel: "Invoice:",
    partnerInvoiceLabel: "Partner invoice:",
  },
  partner: {
    deleteJob: "Delete job",
    deleteJobConfirm: "Delete this job? This action cannot be undone.",
    deleteJobError: "Unable to delete the job.",
  },
  installer: {
    history: "History",
    myDay: "My day",
    myDossiers: "My jobs",
    nothingToday: "Nothing scheduled today",
    jobs: "Jobs",
    planning: "Planning",
    menu: "Menu",
    close: "Close",
    spaceTitle: "Installer space",
    date: "Date",
    time: "Time",
    appointmentDate: "Appointment date",
    appointmentTime: "Appointment time",
    tapToEdit: "Tap to edit",
    imGoing: "I'M GOING",
    call: "CALL",
    noPhone: "No phone number",
    materialUsed: "Material used?",
    new: "New",
    replacement: "Replacement",
    validationSuccess: "Job validated.",
    validationInHistory: "It is now in your history.",
    jobsInProgress: "Jobs in progress",
    noJobsInProgress: "No job in progress",
    viewOnlyInProgress: "In progress — view only",
  },
  signedQuote: {
    title: "Documents",
    loading: "Loading file…",
    loadError: "Unable to display the document. Sign in again or contact your administrator.",
    invalidPath: "Invalid file path.",
    previewAlt: "Document preview",
    openPdf: "Open PDF",
    openImage: "Open image",
    delete: "Delete",
    deleteConfirm: "Delete this document? This cannot be undone.",
    deleteError: "Unable to delete the file.",
    fileTypesHint: "PDF or photo (JPEG, PNG, WebP) — max. {{maxMb}} MB per file",
    tapToUpload: "Tap to add photo(s) or PDF",
    uploading: "Uploading…",
    replaceFile: "Replace existing file (optional)",
    addMore: "Add a document",
    addMoreHint: "You can add multiple files",
    uploadSuccess: "Document saved successfully",
  },
  commercial: {
    appTitle: "Sales space",
    planningOnly: "Schedule",
    logout: "Log out",
    noAppointments: "No scheduled appointments",
    noAppointmentsHint: "Your admin must assign you jobs with a date.",
    backToPlanning: "Back to schedule",
    appointment: "Appointment",
    date: "Date",
    time: "Time",
    openMaps: "Google Maps",
    address: "Address",
    partnerRemarks: "Partner remarks (job file)",
  },
  common: {
    settings: "Account",
    logout: "Log out",
    appearance: "Appearance",
    themeSystem: "System",
    themeLight: "Light",
    themeDark: "Dark",
    roleOwner: "Owner",
    roleAdmin: "Administrator",
    rolePartner: "Partner",
    roleInstaller: "Installer",
    roleCommercial: "Sales",
    langFr: "Français",
    langEn: "English",
    langEs: "Español",
  },
} as const;
